import {
  Component,
  ViewChild,
  TemplateRef,
  ChangeDetectorRef,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  MatTableModule,
} from "@angular/material/table";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import {
  CommonModule,
} from "@angular/common";

import { MatSnackBar } from "@angular/material/snack-bar";
import { LocationTwoService } from "./location-two.service";
import { LocationOneService } from "../location-one/location-one.service.service";
import {
  LocationOneAttributes,
  LocationTwoAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ICreateLocationTwo } from "./interfaces/create-location-two.interface";
import { IUpdateLocationTwo } from "./interfaces/update-location-two.interface";
import { NgSelectModule } from "@ng-select/ng-select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { Subject, Subscription, takeUntil } from "rxjs";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { GeneralFiltersComponent } from "../../filters/general-filters/general-filters.component";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: "app-location-two",
  templateUrl: "./location-two.component.html",
  styleUrls: ["./location-two.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatPaginatorModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    MatSlideToggle,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatSidenavContainer,
    MatSortModule,
    FormsModule,
    NgSelectModule,
    FilterComponent,
    StatusFiltersComponent,
    GeneralFiltersComponent,
    HoverMenuDirective
  ],
  providers: [LocationTwoService,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})
export class LocationTwoComponent implements AfterViewInit , OnDestroy, OnInit{
  displayedColumns: string[] = [ "nombre", "locationOne", "estado", "acciones"];
  currentCreateLocation: ICreateLocationTwo = this.initializeCreateLocation();
  currentUpdateLocation: LocationTwoAttributes | undefined;

  locationOneList: LocationOneAttributes[] = [];

  selectedLocationOneIds: string[] = [];

  filteredLocationOneList: LocationOneAttributes[] = [];

  dataSource: LocationTwoAttributes[] = [];
  private openSelect: any;
  searchQuery = '';
  totalItems = 0;
  pageSize = 50;
  pageIndex = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;


  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;
  destroy$ = new Subject<void>();

  selectedStatuses: number[] = [0,1];

  locationsForm = new FormGroup({
    countryId: new FormControl<string[]>([], [])
  })
  
  constructor(
    private readonly locationOneService: LocationOneService,
    private readonly locationTwoService: LocationTwoService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    // No need for cascade filtering in location-two, just country filtering
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.fetchAllLocations();
    this.findAllWithCount();
  }

  private initializeCreateLocation(): ICreateLocationTwo {
    return { code: "", name: "", locationOneId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount(); 
  }
  
  private fetchAllLocations(): void {
    this.locationOneService.findAll()
    .pipe(
     takeUntil(this.destroy$) 
    )
    .subscribe((res) => {
      this.locationOneList = res?.data ? [...res.data] : [];
      this.filteredLocationOneList = [...this.locationOneList];
    });
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const locationOneIds = this.locationsForm.getRawValue().countryId ? [...this.locationsForm.getRawValue().countryId] : [];

    const locationOneCodes = this.getSelectedLocationCodes(locationOneIds, this.locationOneList);

    this.locationTwoService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        locationOneCodes,
        this.selectedStatuses
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof LocationTwoAttributes {
    const validSortFields: (keyof LocationTwoAttributes)[] = ["code", "name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof LocationTwoAttributes) ? (this.sort.active as keyof LocationTwoAttributes) : "code";
  }

  private getSelectedLocationCodes(selectedIds: string[], locationList: LocationOneAttributes[]): string[] {
    return selectedIds.map((id) => locationList.find((loc) => loc._id.toString() === id)?.code || "");
  }

  // Métodos para manejar la selección - simplified for location-two (no cascade)
  onLocationOneSelectionChange(selectedIds: string[]): void {
    this.selectedLocationOneIds = selectedIds;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: LocationTwoAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    this.locationsForm.reset();
    this.searchQuery = "";
    this.findAllWithCount();
  }

  openCreateModal(): void {
    this.currentCreateLocation = this.initializeCreateLocation();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createLocation());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(location: LocationTwoAttributes): void {
    this.currentUpdateLocation = { ...location };
    // No need for form controls update in location-two as it doesn't have cascade
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateLocation(location._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createLocation(): void {
    this.locationTwoService.create(this.currentCreateLocation).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.fetchAllLocations(); 
        this.resetAllSelections();
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateLocation(id: string): void {
    if (this.currentUpdateLocation) {
      const updatedLocation: IUpdateLocationTwo = {
        locationOneId: this.currentUpdateLocation.locationOne._id.toString(),
        ...this.currentUpdateLocation
      };

      this.locationTwoService.update(id, updatedLocation).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.resetAllSelections();
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, location: LocationTwoAttributes): void {
    const originalStatusId = location.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedLocation = { ...location, statusId: updatedStatusId };

    this.locationTwoService.update(location._id.toString(), updatedLocation).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        location.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(location: LocationTwoAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: location, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(location._id.toString()));
  }

  delete(id: string): void {
    this.locationTwoService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  resetAllSelections(){
    this.locationsForm.reset();
  }

  applyStatusFilter(): void {
    this.findAllWithCount();
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
